/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgCarRent = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M16.677 12H18v2h-1v8h-2v-1.996l-10 .044V22H3v-8H2v-2h1.323l2-5h9.354zM5 15h3v2H5v1.048l10-.044V17h-3v-2h3v-1H5zm.478-3h9.044l-1.199-3H6.677zM19.963 1.265l3.425 3.153-2.772 3.232-.299.35H16V3.8l.303-.295L19.268.623zM18 4.645V6h1.397l1.215-1.417-1.308-1.206z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgCarRent as CarRent };
